export default "__VITE_ASSET__x9psU3EH__"